import { styled } from '@mui/material';

export const DependentListContainerStyled = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'flex-start',
  gap: '12px',
  flexWrap: 'wrap',
  overflow: 'auto',
});
